export default __webpack_public_path__ + "static/media/doc3.8557b5b9.jpg";